import React from 'react'
import './Registration.css'
import Layout from '../Layout'
import SignupFunction from '../../../utils/CommonFunctionality/SignupFunction'

const Registration = (props) => {
    return (
        <Layout>
            <div className="clearfix row regCnt">
                <div className="col-12">
                    <div className="loginFormBox">
                        <SignupFunction
                            defaultCountryCode={73}
                            title="Signup"
                            subTitle="Create your free account today"
                            regpro={props}
                            needCountrybox={1}
                            captcha={1}
                            phone_country_code_must={1}
                        />
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default Registration
